export default __webpack_public_path__ + "static/media/engageCICBriefingbg.c596e7bc.jpg";